export const getPropsModel = (date, labeledFamilyCenterId) => ({
  match: {
    params: {
      familyId: labeledFamilyCenterId,
      date,
      datetype: 2
    }
  }
})
